import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelopeOpenText, faPaperPlane, faTriangleExclamation, faSpinner } from "@fortawesome/free-solid-svg-icons";

// 1 thẻ KPI: icon nền nhạt + số to + nhãn + dòng phụ. Màu nền/chữ dùng token semantic
// (bg-surface, text-content…) để đúng cả chế độ sáng lẫn tối.
function StatCard({ icon, label, value, hint, iconClass, spin }) {
    return (
        <div className="flex items-center gap-3 p-4 rounded-xl border border-line bg-surface">
            <div className={`w-11 h-11 rounded-xl flex items-center justify-center text-lg shrink-0 ${iconClass}`}>
                <FontAwesomeIcon icon={icon} spin={spin} />
            </div>
            <div className="min-w-0">
                <div className="text-xl font-bold leading-tight text-content">{value}</div>
                <div className="text-[13px] text-content-3">{label}</div>
                {hint && <div className="text-xs text-content-3 truncate">{hint}</div>}
            </div>
        </div>
    );
}

/**
 * Hàng KPI tổng quan cho trang danh sách Email Campaign.
 * stats lấy từ GET /admin/email/campaigns (luôn tính trên toàn bảng, không theo bộ lọc).
 */
function EmailCampaignSummaryBar({ stats = {} }) {
    const { total = 0, draft = 0, sending = 0, done = 0, failed = 0, totalSent = 0, totalFailed = 0 } = stats;
    const attempted = totalSent + totalFailed;
    const failRate = attempted ? ((totalFailed / attempted) * 100).toFixed(1) : "0";
    const fmt = (n) => Number(n || 0).toLocaleString();

    const cards = [
        {
            icon: faEnvelopeOpenText,
            label: "Tổng chiến dịch",
            value: fmt(total),
            hint: `${fmt(done)} hoàn thành · ${fmt(draft)} nháp`,
            iconClass: "bg-blue-100 text-blue-600",
        },
        {
            icon: faPaperPlane,
            label: "Email đã gửi",
            value: fmt(totalSent),
            hint: "Cộng dồn mọi chiến dịch",
            iconClass: "bg-green-100 text-green-600",
        },
        {
            icon: faTriangleExclamation,
            label: "Tỷ lệ gửi lỗi",
            value: `${failRate}%`,
            hint: `${fmt(totalFailed)} email lỗi${failed ? ` · ${fmt(failed)} chiến dịch thất bại` : ""}`,
            iconClass: "bg-red-100 text-red-600",
        },
        {
            icon: faSpinner,
            label: "Đang gửi",
            value: fmt(sending),
            hint: sending ? "Tự làm mới mỗi 10 giây" : "Không có chiến dịch nào chạy",
            iconClass: "bg-amber-100 text-amber-600",
            spin: sending > 0,
        },
    ];

    return (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
            {cards.map((c) => <StatCard key={c.label} {...c} />)}
        </div>
    );
}

export default EmailCampaignSummaryBar;
